import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useScreenWidth } from "hooks/useScreenWidth";
import { QueryParamProvider } from "providers/queryParams";
import { Outlet } from "react-router-dom";

import { CommandPaletteProvider } from "./components/CommandPaletteProvider";
import { CspViolationReporter } from "./components/CspViolationReporter";
import { MinimizedDialogsToolbar } from "./components/MinimizedDialogs/MinimizedDialogsToolbar";
import { PrevNextNavigationProvider } from "./components/PrevNextNavigation";
import { SharedGoogleMapsProvider } from "./components/SharedGoogleMapsProvider";
import { BreadcrumbProvider } from "./providers/breadcrumbs";
import { DocumentAIAnalysisProvider } from "./providers/documentAIAnalysis";
import { DocumentReviewProvider } from "./providers/documentReview";
import { MinimizedDialogsProvider } from "./providers/minimizedDialogs";
import { useEncampTheme } from "./theme";

export function App() {
  const { screenMaxWidth } = useScreenWidth();

  const encampTheme = useEncampTheme();

  return (
    <QueryParamProvider>
      <CspViolationReporter />
      <ThemeProvider theme={encampTheme}>
        <CssBaseline />
        <MinimizedDialogsProvider>
          <DocumentReviewProvider>
            <DocumentAIAnalysisProvider>
              <CommandPaletteProvider>
                <PrevNextNavigationProvider>
                  <BreadcrumbProvider>
                    <SharedGoogleMapsProvider>
                      <Box sx={screenMaxWidth ? { maxWidth: screenMaxWidth } : {}}>
                        <Outlet />
                      </Box>
                      <MinimizedDialogsToolbar />
                    </SharedGoogleMapsProvider>
                  </BreadcrumbProvider>
                </PrevNextNavigationProvider>
              </CommandPaletteProvider>
            </DocumentAIAnalysisProvider>
          </DocumentReviewProvider>
        </MinimizedDialogsProvider>
      </ThemeProvider>
    </QueryParamProvider>
  );
}
